import { render, staticRenderFns } from "./table-pagination.vue?vue&type=template&id=993ccad6"
import script from "./table-pagination.vue?vue&type=script&lang=ts"
export * from "./table-pagination.vue?vue&type=script&lang=ts"
import style0 from "./table-pagination.vue?vue&type=style&index=0&id=993ccad6&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('993ccad6')) {
      api.createRecord('993ccad6', component.options)
    } else {
      api.reload('993ccad6', component.options)
    }
    module.hot.accept("./table-pagination.vue?vue&type=template&id=993ccad6", function () {
      api.rerender('993ccad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/table/table-pagination.vue"
export default component.exports